import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface IAvatarUser {
  name: string;
}

@Component({
  selector: 'kon-user-avatar',
  standalone: true,
  imports: [CommonModule],
  template: ` <div
    class="rounded-full bg-primary-50 flex items-center justify-center uppercase font-medium text-primary-700"
    [style.width]="size"
    [style.height]="size"
  >
    {{ initial }}
  </div>`,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  @Input({ required: true }) user!: IAvatarUser;
  @Input() size = '32px';

  get initial(): string {
    return this.user?.name?.[0];
  }
}
